import React from "react";
import NavBarComponent from "../NavBarComponent";
import { Col, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCode } from "@fortawesome/free-solid-svg-icons/faCode";
import { faDatabase } from "@fortawesome/free-solid-svg-icons";
import { faGithub } from "@fortawesome/free-brands-svg-icons";
import { faFileCsv } from "@fortawesome/free-solid-svg-icons";
import { faTools } from "@fortawesome/free-solid-svg-icons";
import { faLanguage } from "@fortawesome/free-solid-svg-icons";
import styled from "styled-components";

import Footer from "../Footer/Footer";
import { H1Heading, H3Heading, H5Heading } from "../../common/CommonStyles";

const FIcon = styled(FontAwesomeIcon)`
  font-size: 80px;
  color: #eeee;
`;
const WrapperComponent = styled.section`
  margin-top: 25px;
  text-align: center;
  position: relative;
`;

const SkillsCol = styled(Col)`
  margin: 18px auto;
`;
function Skills() {
  return (
    <>
      <NavBarComponent />
      <div>
        <WrapperComponent class="skill-div">
          <H1Heading>Skills</H1Heading>
          <H3Heading>Things I'm proficient in working with!</H3Heading>

          <Row style={{ margin: "30px auto" }}>
            <SkillsCol md={6} lg={4}>
              <FIcon icon={faCode} />
              <H5Heading>
                Programming with Python, Java,
                <br /> JS, C++, C
              </H5Heading>
            </SkillsCol>
            <SkillsCol md={6} lg={4}>
              <FIcon icon={faDatabase} />
              <H5Heading>
                Database management using <br />
                SQL, Firebase
              </H5Heading>
            </SkillsCol>
            <SkillsCol md={6} lg={4}>
              <FIcon icon={faGithub} />
              <H5Heading>Git</H5Heading>
            </SkillsCol>
            <SkillsCol md={6} lg={4}>
              <FIcon icon={faFileCsv} />
              <H5Heading>
                Data Extraction, Data Cleaning, <br />
                Data Visualisation, Model Training
              </H5Heading>
            </SkillsCol>
            <SkillsCol md={6} lg={4}>
              <FIcon icon={faTools} />
              <H5Heading>
                Embedded Electronics, PIC Microcontrollers, <br />
                ARM Processors, Assembly Language
              </H5Heading>
            </SkillsCol>
            <SkillsCol md={6} lg={4}>
              <FIcon icon={faLanguage} />
              <H5Heading>
                Foreign Language Enthusiast <br /> JLPT N5 Certified
              </H5Heading>
            </SkillsCol>
          </Row>
        </WrapperComponent>
        <Footer />
      </div>
    </>
  );
}

export default Skills;
